import * as fromShift from '../actions/shift.action';

export interface ShiftState {
  data: any;
  error: any;
  loading: boolean;
  loaded: boolean;
  saving: boolean;
  saved: boolean;
}

export const initialState = {
  data: null,
  error: null,
  loading: false,
  loaded: false,
  saving: false,
  saved: false,
};

export function reducer(state = initialState, action: fromShift.ShiftAction): ShiftState {
  switch (action.type) {

    case fromShift.GET_ALL_SHIFTS: {
      return {
        ...state,
        data: null,
        loading: true,
        loaded: false,
        error: null
      };
    }

    case fromShift.GET_ALL_SHIFTS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loaded: true,
        loading: false,
      };
    }

    case fromShift.GET_ALL_SHIFTS_FAIL: {
      return {
        ...state,
        error: action.payload,
        loaded: true,
        loading: false
      };
    }

    case fromShift.GET_SHIFT_DETAILS: {
      return {
        ...state,
        data: null,
        loading: true,
        loaded: false,
        error: null
      };
    }

    case fromShift.GET_SHIFT_DETAILS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loaded: true,
        loading: false,
      };
    }

    case fromShift.GET_SHIFT_DETAILS_ERROR: {
      return {
        ...state,
        error: action.payload,
        loaded: true,
        loading: false
      };
    }

    case fromShift.CREATE_SHIFT: {
      return {
        ...state,
        error: null,
        saving: true,
        saved: false,
      };
    }
    case fromShift.CREATE_SHIFT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        saving: false,
        saved: true,
      };
    }

    case fromShift.CREATE_SHIFT_FAIL: {
      return {
        ...state,
        error: action.payload,
        saving: false,
        saved: false,
      };
    }
    case fromShift.DELETE_SHIFT: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }

    case fromShift.DELETE_SHIFT_SUCCESS: {
      return {
        ...state,
        data: null,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromShift.DELETE_SHIFT_FAIL: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shifts/store/reducers/shift.reducer.ts